import { commonStyles } from "src/Library/CommonStyles";
import { tokens } from 'src/design-system';

export const DiscoverRatesFiltersStyles = (theme) => ({
  mainDiv: {
    width: '100%',
    paddingLeft: tokens.spacing.lg,
    marginTop: '5px',
  },
  cardStyle: {
    backgroundColor: '#FDFDFD',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: tokens.spacing.ms,
    fontSize: tokens.fontSize.small,
    marginTop: tokens.spacing.sm,
    border: `1px solid ${tokens.colors.bgSubtle}`,
    borderRadius: tokens.radius.lg,
    boxShadow: ' 2px 0 12px 0 rgba(0, 0, 0, 0.08)',
    paddingLeft: tokens.spacing.md,
  },
  noOfContainers: {
    backgroundColor: '#FDFDFD',
    '& .ant-input-number-input-wrap': {
      color: tokens.colors.primaryDark,
      fontWeight: tokens.fontWeight.semibold,
    },
  },
  weightInput: {
    border: 'unset',
    boxShadow: 'unset !important',
    marginRight: '5px',
    boxSizing: 'unset',
    width: '65px',
    backgroundColor: '#FDFDFD',
    '& .ant-input-number-input-wrap': {
      color: tokens.colors.primaryDark,
      fontWeight: tokens.fontWeight.semibold,
      '& .ant-input-number-input': {
        textAlign: 'right',
      },
    },
    '& .ant-input-number-handler-wrap': {
      display: 'none',
    },
  },
  weightSelect: {
    '& .ant-select-dropdown': {
      minWidth: '45px',
    },
    '& .ant-select-selection': {
      backgroundColor: '#FDFDFD',
      border: 0,
      boxShadow: 'unset !important',
      '& .ant-select-selection__rendered': {
        marginRight: '30px',
      },
      '& .ant-select-selection-selected-value': {
        fontWeight: tokens.fontWeight.semibold,
      },
    },
  },
  selectDropdown: {
    '& .ant-select-dropdown-menu-item': {
      '&:hover': {
        backgroundColor: tokens.colors.primaryDark,
        color: tokens.colors.bgWhite,
      },
    },
    '& .ant-select-dropdown-menu-item-selected': {
      backgroundColor: tokens.colors.primaryDark,
      color: tokens.colors.bgWhite,
    },
  },
  datepicker: {
    cursor: 'pointer',
    width: '60%',
    '& .ant-calendar-picker-input': {
      border: 0,
      boxShadow: 'unset !important',
      cursor: 'pointer',
      textAlign: 'center',
      color: tokens.colors.primaryDark,
      fontSize: tokens.fontSize.small,
      fontWeight: tokens.fontWeight.semibold,
      backgroundColor: '#FDFDFD',
    },
  },
  shippingLines: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: tokens.spacing.ms,
    maxHeight: '270px',
    overflow: 'auto',
    fontSize: tokens.fontSize.small,
    paddingLeft: tokens.spacing.sm,
    color: tokens.colors.textSecondary,
    '& .ant-checkbox-wrapper-checked': {
      fontWeight: tokens.fontWeight.semibold,
    },
    '& .ant-checkbox-group-item': {
      fontSize: tokens.fontSize.small,
      margin: '5px 0px',
      fontWeight: tokens.fontWeight.semibold,
      display: 'flex',
      color: tokens.colors.textSecondary,
      alignItems: 'end',
    },
    '& .ant-checkbox-checked .ant-checkbox-inner': {
      backgroundColor: tokens.colors.primaryDark,
      borderColor: tokens.colors.primaryDark,
    },
    ...commonStyles(theme).fixedScrollbar,
  },
  transitDays: {
    color: '#DC3C42',
    fontWeight: tokens.fontWeight.semibold,
    cursor: 'pointer',
  },
  clearAllButton: {
    fontSize: tokens.fontSize.small,
    color: '#DC3C42',
    cursor: 'pointer',
    marginLeft: tokens.spacing.md,
  },
  containerInput: {
    minWidth: '38px',
    maxWidth: '70px',
    '& .ant-input-number-input': {
      textAlign: 'center',
    },
  },
  centerDiv: {
    display: 'flex',
    alignItems: 'center',
  },
  tooltipIcon: {
    color: '#FAD174',
    fontSize: tokens.fontSize.body,
    marginRight: tokens.spacing.sm,
  },
  containerTooltip: {
    display: 'flex',
    alignItems: 'center',
    fontSize: tokens.fontSize.caption,
  },
  slider: {
    '& .ant-slider-track': {
      backgroundColor: tokens.colors.primaryDark,
      height: '2px',
    },
    '& .ant-slider-handle': {
      backgroundColor: tokens.colors.primaryDark,
      border: `2px solid ${tokens.colors.bgWhite}`,
    },
    '& .ant-slider-mark-text': {
      position: 'static',
    },
    '& .ant-slider-mark > span:nth-child(1)': {
      float: 'left',
      marginLeft: '-5px',
      transform: 'none !important',
    },
    '& .ant-slider-mark > span:nth-child(2)': {
      float: 'right',
      marginRight: '-5px',
      transform: 'none !important',
    },
  },
  search: {
    margin: '10px 0',
    '& .ant-input-affix-wrapper': {
      backgroundColor: '#FDFDFD',
    },
    '& .ant-input': {
      backgroundColor: '#FDFDFD !important',
      border: '0 !important',
      borderBottom: `1px solid ${tokens.colors.border} !important`,
      fontSize: tokens.fontSize.small,
      padding: 0,
      borderRadius: 0,
      boxShadow: 'unset !important',
    },
  },
  ffType: {
    color: '#999999',
    fontStyle: 'italic',
    fontSize: '8px',
  },
  ffList: {
    fontSize: tokens.fontSize.caption,
    margin: '6px 0',
    ...commonStyles(theme).justifySpaceBetween,
    alignItems: 'center',
  },
  ffCheckbox: {
    display: 'flex',
    '& .ant-checkbox + span': {
      fontSize: tokens.fontSize.caption,
      fontWeight: tokens.fontWeight.semibold,
      color: tokens.colors.textSecondary,
      ...commonStyles(theme).ellipses,
      maxWidth: '140px',
    },
  },
  ffListDiv: {
    maxHeight: '180px',
    paddingRight: '2px',
    overflowY: 'auto',
    marginLeft: tokens.spacing.sm,
    ...commonStyles(theme).fixedScrollbar,
  },
  rowDiv: {
    width: '100%',
    marginBottom: '0px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  weight: {
    marginBottom: tokens.spacing.xs,
    fontSize: tokens.fontSize.caption,
    height: '30px',
    paddingLeft: '6px',
  },
  serviceFilterLabel: {
    fontSize: tokens.fontSize.caption,
    color: '#595959',
    fontWeight: tokens.fontWeight.semibold,
  },
});
